import React from 'react';
import { useToggle } from '~/helpers/data';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus';
import './collapsing-pane.scss';
export default function CollapsingPane({ title, children }) {
    const [isOpen, toggle] = useToggle(false);
    const plusOrMinus = isOpen ? faMinus : faPlus;
    return (React.createElement("details", { className: "collapsing-pane", open: isOpen, onToggle: () => toggle() },
        React.createElement("summary", { className: "control-bar" },
            React.createElement("div", null, title),
            React.createElement(FontAwesomeIcon, { icon: plusOrMinus })),
        React.createElement("div", null, children)));
}
